(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-cross-sell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cart-cross-sell')) {
    customElements.define(
      'cart-cross-sell',
      class CartCrossSell extends HTMLElement {
        connectedCallback() {
          this.unsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-cross-sell') return;
            this.refresh();
          });
        }

        disconnectedCallback() {
          if (this.unsubscriber) this.unsubscriber();
        }

        refresh() {
          // section_id debe ser el ID de instancia de templates/cart.json
          // (section.id), no el type/filename de la sección — para
          // main-cart-footer ambos difieren ("cart-footer" vs
          // "main-cart-footer"), y usar el type devuelve una sección sin
          // bloques resueltos. Se lee de data-id en runtime, igual que
          // getSectionsToRender() en cart.js.
          const crossSellSectionId = this.dataset.id;
          const footerSectionId = document.getElementById('main-cart-footer').dataset.id;

          Promise.all([
            fetch(`${window.routes.cart_url}?section_id=${crossSellSectionId}`).then((response) => response.text()),
            fetch(`${window.routes.cart_url}?section_id=${footerSectionId}`).then((response) => response.text()),
          ])
            .then(([crossSellHtml, footerHtml]) => {
              const crossSellDoc = new DOMParser().parseFromString(crossSellHtml, 'text/html');
              const crossSellSource = crossSellDoc.querySelector('#cart-cross-sell .js-contents');
              const crossSellTarget = this.querySelector('.js-contents');
              if (crossSellSource && crossSellTarget) {
                crossSellTarget.innerHTML = crossSellSource.innerHTML;
              }
              this.classList.toggle('is-empty', !crossSellSource?.querySelector('.cart-cross-sell__item'));

              const footerDoc = new DOMParser().parseFromString(footerHtml, 'text/html');
              const footerSource = footerDoc.querySelector('#main-cart-footer .js-contents');
              const footerTarget = document.querySelector('#main-cart-footer .js-contents');
              if (footerSource && footerTarget) {
                footerTarget.innerHTML = footerSource.innerHTML;
              }
            })
            .catch((e) => console.error(e));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison"] && !Shopify.designMode) return;
  try {
    
  class ComparisonTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.activeIndex = Math.max(
        0,
        this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
      );

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
    }

    onClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;
      this.activate(this.tabs.indexOf(tab));
    }

    onKeydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;

      const index = this.tabs.indexOf(tab);
      const { key } = event;
      const lastIndex = this.tabs.length - 1;
      let nextIndex = null;

      if (key === 'ArrowRight') {
        nextIndex = index === lastIndex ? 0 : index + 1;
      } else if (key === 'ArrowLeft') {
        nextIndex = index === 0 ? lastIndex : index - 1;
      } else if (key === 'Home') {
        nextIndex = 0;
      } else if (key === 'End') {
        nextIndex = lastIndex;
      } else if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        this.activate(index);
        return;
      } else {
        return;
      }

      event.preventDefault();
      this.activate(nextIndex);
      this.tabs[nextIndex].focus();
    }

    activate(index) {
      if (index === this.activeIndex) return;

      const previousPanel = this.panels[this.activeIndex];
      const nextPanel = this.panels[index];

      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });

      if (previousPanel && nextPanel && previousPanel !== nextPanel) {
        previousPanel.classList.add('is-hidden');

        window.setTimeout(() => {
          previousPanel.hidden = true;
          nextPanel.hidden = false;
          void nextPanel.offsetHeight;
          nextPanel.classList.remove('is-hidden');
        }, 250);
      }

      this.activeIndex = index;
    }
  }

  customElements.define('comparison-tabs', ComparisonTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form-block"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    var honeypot = document.getElementById('ContactForm-hp');
    if (!honeypot) return;

    form.addEventListener('submit', function (event) {
      if (honeypot.value !== '') {
        event.preventDefault();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.threshold = Number(this.dataset.threshold) || 600;
      this.onScroll = this.onScroll.bind(this);
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.button.addEventListener('click', this.onClick);
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.button.removeEventListener('click', this.onClick);
    }

    onScroll() {
      const scrolled = window.scrollY || document.documentElement.scrollTop;
      this.classList.toggle('footer__back-to-top--visible', scrolled > this.threshold);
    }

    onClick() {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    }
  }

  customElements.define('back-to-top', BackToTop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 6000;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer = null;
      this.touchStartX = undefined;
      this.touchStartY = undefined;

      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.pause = this.pause.bind(this);
      this.play = this.play.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
    }

    connectedCallback() {
      this.prevButton = this.querySelector('.hero-slider__arrow--prev');
      this.nextButton = this.querySelector('.hero-slider__arrow--next');
      this.counterCurrent = this.querySelector('.hero-slider__counter-current');

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);

      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.play);
      this.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.addEventListener('touchend', this.onTouchEnd);

      this.play();
    }

    disconnectedCallback() {
      this.pause();
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      this.removeEventListener('mouseenter', this.pause);
      this.removeEventListener('mouseleave', this.play);
      this.removeEventListener('touchstart', this.onTouchStart);
      this.removeEventListener('touchend', this.onTouchEnd);
    }

    play() {
      if (this.prefersReducedMotion || this.slides.length < 2) return;
      this.pause();
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    onPrevClick() {
      this.goTo(this.currentIndex - 1);
      this.play();
    }

    onNextClick() {
      this.goTo(this.currentIndex + 1);
      this.play();
    }

    onTouchStart(event) {
      const touch = event.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    onTouchEnd(event) {
      if (this.touchStartX === undefined) return;

      const touch = event.changedTouches[0];
      const dx = touch.clientX - this.touchStartX;
      const dy = touch.clientY - this.touchStartY;

      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        this.goTo(dx < 0 ? this.currentIndex + 1 : this.currentIndex - 1);
        this.play();
      }

      this.touchStartX = undefined;
      this.touchStartY = undefined;
    }

    goTo(index) {
      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const current = this.slides[this.currentIndex];
      const next = this.slides[nextIndex];

      current.classList.remove('is-active');
      current.inert = true;
      next.classList.add('is-active');
      next.inert = false;

      this.currentIndex = nextIndex;

      if (this.counterCurrent) {
        this.counterCurrent.textContent = String(nextIndex + 1).padStart(2, '0');
      }
    }
  }

  customElements.define('hero-slider', HeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immersive-carousel"] && !Shopify.designMode) return;
  try {
    
  class ImmersiveCarousel extends HTMLElement {
    constructor() {
      super();
      this.items = Array.from(this.querySelectorAll('.immersive-carousel__item'));
      this.dots = Array.from(this.querySelectorAll('.immersive-carousel__dot'));
      this.base = this.querySelector('.immersive-carousel__bg-base');
      this.ripple = this.querySelector('.immersive-carousel__bg-ripple');
      this.info = this.querySelector('.immersive-carousel__info');
      this.infoName = this.querySelector('.immersive-carousel__info-name');
      this.infoPrice = this.querySelector('.immersive-carousel__info-price');
      this.variantInput = this.querySelector('.immersive-carousel__form .product-variant-id');
      this.addButton = this.querySelector('.immersive-carousel__add-button');
      this.addButtonLabel = this.addButton ? this.addButton.querySelector('span') : null;
      this.prevButton = this.querySelector('.immersive-carousel__arrow--prev');
      this.nextButton = this.querySelector('.immersive-carousel__arrow--next');

      this.total = this.items.length;
      this.activeIndex = 0;
      this.isAnimating = false;
      this.touchStartX = undefined;
      this.touchStartY = undefined;

      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onDotClick = this.onDotClick.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
    }

    connectedCallback() {
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
      this.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.addEventListener('touchend', this.onTouchEnd);

      this.applyRoles();

      if (this.base && this.items[this.activeIndex]) {
        this.base.style.backgroundColor = this.items[this.activeIndex].dataset.bgColor;
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
      this.removeEventListener('touchstart', this.onTouchStart);
      this.removeEventListener('touchend', this.onTouchEnd);
    }

    getRole(itemIndex) {
      let diff = (itemIndex - this.activeIndex + this.total) % this.total;
      if (diff > this.total / 2) diff -= this.total;

      switch (diff) {
        case 0:
          return 'center';
        case 1:
          return 'right';
        case -1:
          return 'left';
        case 2:
          return 'backRight';
        case -2:
          return 'backLeft';
        default:
          return 'hidden';
      }
    }

    applyRoles() {
      this.items.forEach((item, index) => {
        const role = this.getRole(index);
        item.dataset.role = role;
        item.inert = role !== 'center';
      });
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.activeIndex);
      });
    }

    updateInfo(index) {
      const item = this.items[index];
      if (!item) return;

      if (this.infoName) this.infoName.textContent = item.dataset.title;
      if (this.infoPrice) this.infoPrice.textContent = item.dataset.price;

      const available = item.dataset.available === 'true';

      if (this.variantInput) {
        this.variantInput.value = item.dataset.variantId;
        this.variantInput.disabled = !available;
      }

      if (this.addButton) this.addButton.disabled = !available;
      if (this.addButtonLabel) {
        this.addButtonLabel.textContent = available
          ? this.addButtonLabel.dataset.addLabel
          : this.addButtonLabel.dataset.soldOutLabel;
      }
    }

    onPrevClick() {
      this.goTo(this.activeIndex - 1);
    }

    onNextClick() {
      this.goTo(this.activeIndex + 1);
    }

    onDotClick(event) {
      this.goTo(Number(event.currentTarget.dataset.index));
    }

    onTouchStart(event) {
      const touch = event.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    onTouchEnd(event) {
      if (this.touchStartX === undefined) return;

      const touch = event.changedTouches[0];
      const dx = touch.clientX - this.touchStartX;
      const dy = touch.clientY - this.touchStartY;

      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        this.goTo(dx < 0 ? this.activeIndex + 1 : this.activeIndex - 1);
      }

      this.touchStartX = undefined;
      this.touchStartY = undefined;
    }

    setArrowsDisabled(disabled) {
      if (this.prevButton) this.prevButton.disabled = disabled;
      if (this.nextButton) this.nextButton.disabled = disabled;
    }

    goTo(index) {
      if (this.isAnimating || this.total < 2) return;

      const nextIndex = (index + this.total) % this.total;
      if (nextIndex === this.activeIndex) return;

      this.isAnimating = true;
      this.setArrowsDisabled(true);

      if (this.info) this.info.classList.add('is-hidden');

      if (this.ripple) {
        this.ripple.style.backgroundColor = this.items[nextIndex].dataset.bgColor;
        requestAnimationFrame(() => {
          this.ripple.style.clipPath = 'circle(150% at 50% 50%)';
        });
      }

      this.activeIndex = nextIndex;
      this.applyRoles();
      this.updateDots();

      window.setTimeout(() => {
        this.updateInfo(nextIndex);
        if (this.info) this.info.classList.remove('is-hidden');
      }, 200);

      window.setTimeout(() => {
        if (this.base) this.base.style.backgroundColor = this.items[nextIndex].dataset.bgColor;
        this.resetRipple();
        this.isAnimating = false;
        this.setArrowsDisabled(false);
      }, 650);
    }

    resetRipple() {
      if (!this.ripple) return;
      this.ripple.classList.add('immersive-carousel__bg-ripple--instant');
      this.ripple.style.clipPath = 'circle(0% at 50% 50%)';
      void this.ripple.offsetHeight;
      this.ripple.classList.remove('immersive-carousel__bg-ripple--instant');
    }
  }

  customElements.define('immersive-carousel', ImmersiveCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-grid"] && !Shopify.designMode) return;
  try {
    
  class InstagramCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.instagram-grid__track');
      this.controls = this.querySelector('.instagram-grid__controls');
      this.prevButton = this.querySelector('.instagram-grid__arrow--prev');
      this.nextButton = this.querySelector('.instagram-grid__arrow--next');
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onScroll = this.onScroll.bind(this);
      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      if (!this.track) return;

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);

      if (this.controls) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.track);
      }

      this.updateControlsVisibility();
      this.updateButtons();
    }

    disconnectedCallback() {
      this.track.removeEventListener('scroll', this.onScroll);
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    onScroll() {
      this.updateButtons();
    }

    onResize() {
      this.updateControlsVisibility();
      this.updateButtons();
    }

    updateControlsVisibility() {
      if (!this.controls) return;
      const overflows = this.track.scrollWidth > this.track.clientWidth + 1;
      this.controls.hidden = !overflows;
    }

    updateButtons() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft >= maxScroll - 1;

      if (this.prevButton) this.prevButton.disabled = atStart;
      if (this.nextButton) this.nextButton.disabled = atEnd || maxScroll <= 0;
    }

    onPrevClick() {
      this.scrollByPage(-1);
    }

    onNextClick() {
      this.scrollByPage(1);
    }

    scrollByPage(direction) {
      this.track.scrollBy({
        left: direction * this.track.clientWidth,
        behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
      });
    }
  }

  customElements.define('instagram-carousel', InstagramCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Dawn's product-info.js always calls media-gallery's setActiveMedia with
  // prepend:true on variant change, reordering the thumbnail/slide DOM so the
  // active item jumps to the front. Norfeu's gallery order (Individual,
  // Familiar, Textura, Lifestyle) must stay fixed — only the active/current
  // state should change. Patched here instead of editing the native Dawn
  // files, so it survives theme updates. whenDefined avoids any dependency
  // on script load order.
  customElements.whenDefined('media-gallery').then(() => {
    const proto = customElements.get('media-gallery').prototype;
    if (proto.__norfeuNoPrependPatch) return;
    const originalSetActiveMedia = proto.setActiveMedia;
    proto.setActiveMedia = function (mediaId) {
      return originalSetActiveMedia.call(this, mediaId, false);
    };
    proto.__norfeuNoPrependPatch = true;
  });

  // Dawn hides the main viewer's prev/next arrows on desktop for the
  // thumbnail/thumbnail_slider gallery layouts (section-main-product.css
  // targets `.product__media-container .slider-buttons`), because on
  // desktop `.product__media-item:not(.is-active)` is display:none, so
  // SliderComponent's scrollTo-based navigation has no scroll width to move
  // through. Norfeu's markup doesn't use that wrapper class, so the arrows
  // stay visible — wire them to the same setActiveMedia mechanism the
  // thumbnails already use, navigating to the next/previous media id with
  // wraparound, instead of relying on the scroll-based slider.
  customElements.whenDefined('media-gallery').then(() => {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.__norfeuArrowNavPatch) return;
      gallery.__norfeuArrowNavPatch = true;

      const viewer = gallery.elements && gallery.elements.viewer;
      if (!viewer) return;

      const prevButton = viewer.querySelector('button[name="previous"]');
      const nextButton = viewer.querySelector('button[name="next"]');
      if (!prevButton || !nextButton) return;

      const navigate = (step) => {
        // Scoped to the slide `<li>` elements (id^="Slide-"), matching
        // SliderComponent's own convention. product-thumbnail.liquid also
        // stamps an unprefixed data-media-id on an element nested inside
        // each slide, so a plain `[data-media-id]` query here would pick up
        // both and resolve the wrong element as "active".
        const slides = Array.from(viewer.querySelectorAll('[id^="Slide-"]'));
        if (slides.length < 2) return;

        const currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const safeCurrentIndex = currentIndex === -1 ? 0 : currentIndex;
        const nextIndex = (safeCurrentIndex + step + slides.length) % slides.length;
        const mediaIds = slides.map((slide) => slide.dataset.mediaId);
        gallery.setActiveMedia(mediaIds[nextIndex]);

        // SliderComponent's "x / y" counter only updates on its own scroll
        // event, which never fires here since navigation happens via
        // setActiveMedia's class toggling, not scrollTo. Keep it in sync
        // manually.
        const counterElement = viewer.querySelector('.slider-counter--current');
        if (counterElement) counterElement.textContent = nextIndex + 1;
      };

      prevButton.addEventListener('click', () => navigate(-1));
      nextButton.addEventListener('click', () => navigate(1));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.product-carousel__track');
      this.prevButton = this.querySelector('.product-carousel__arrow--prev');
      this.nextButton = this.querySelector('.product-carousel__arrow--next');
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onScroll = this.onScroll.bind(this);
      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
    }

    connectedCallback() {
      if (!this.track) return;

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);

      this.updateButtons();
    }

    disconnectedCallback() {
      this.track.removeEventListener('scroll', this.onScroll);
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
    }

    onScroll() {
      this.updateButtons();
    }

    updateButtons() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft >= maxScroll - 1;

      if (this.prevButton) this.prevButton.disabled = atStart;
      if (this.nextButton) this.nextButton.disabled = atEnd || maxScroll <= 0;
    }

    onPrevClick() {
      this.scrollByPage(-1);
    }

    onNextClick() {
      this.scrollByPage(1);
    }

    scrollByPage(direction) {
      this.track.scrollBy({
        left: direction * this.track.clientWidth,
        behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
      });
    }
  }

  customElements.define('product-carousel', ProductCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-reveal-text"] && !Shopify.designMode) return;
  try {
    
  class ScrollRevealText extends HTMLElement {
    constructor() {
      super();
      this.words = Array.from(this.querySelectorAll('.scroll-reveal-text__word'));
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.updateOpacities = this.updateOpacities.bind(this);
    }

    connectedCallback() {
      if (this.words.length === 0) return;

      if (this.prefersReducedMotion) {
        this.words.forEach((word) => {
          word.style.opacity = 1;
        });
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.updateOpacities();
          } else {
            window.removeEventListener('scroll', this.onScroll);
          }
        },
        { rootMargin: '50% 0px 50% 0px' }
      );
      this.observer.observe(this);

      this.updateOpacities();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.observer) this.observer.disconnect();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateOpacities();
        this.ticking = false;
      });
    }

    updateOpacities() {
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const start = viewportHeight * 0.8;
      const end = -(rect.height - viewportHeight * 0.43);
      let progress = (start - rect.top) / (start - end);
      progress = Math.min(1, Math.max(0, progress));

      const total = this.words.length;
      const revealPosition = progress * (total - 1 + 1.5);

      this.words.forEach((word, index) => {
        const distance = revealPosition - index;
        const wordProgress = Math.min(1, Math.max(0, distance / 1.5));
        word.style.opacity = String(0.55 + 0.45 * wordProgress);
      });
    }
  }

  customElements.define('scroll-reveal-text', ScrollRevealText);

  } catch(e) { console.error(e); }
})();
})();
